
import { useEffect, useState } from 'react';
import { Singleton } from '../../../../../core/services/Singleton';
import { BasicTable, MASK_DATE } from '../../../../theme/Component/BasicTable';
import { toast } from 'react-toastify';
import { StateReimbursementEditor } from './StateReimbursementEditor';
import { BasicPage } from '../../../../theme/Component/BasicPage';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { ListMenu } from '../../../../theme/Component/ListMenu';
import { Modal } from '../../../../theme/Component/Modal';
import { CashReimbursementBudget } from './CashReimbursementBudget';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _CashReimbursement, _CashReimbursementBudget, _DocumentFactory, _single } from '../../../../../core/services/dataBean/EntityCatalog';
import { ModalConfirm } from '../../../../theme/Component/ModalConfirm';
import { CashReimbursementItem } from './CashReimbursementItem';
import { EstablishBaseCashReimbursement } from './EstablishBaseCashReimbursement';
import { CashDeskAccountSelector } from '../../CashDeskAccount/CashDeskAccountSelector';
import { RPsEditor } from '../../../../contabilidad/budgetObligationFactory/RPsEditor';
import { SelectorDocumentFactory } from '../../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory';
import { DocumentStorageEditor } from '../../../../contabilidad/bodegaDocumentos/DocumentStorageEditor';
import { BudgetListForRefund } from './BudgetListForRefund/BudgetListForRefund';
import { DocumentViewer } from '../../../../theme/Component/DocumentViewer';
import { _Egress } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import { ThirdBankingAccountEditor } from '../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor';
import { InputDate } from '../../../../theme/Input/InputDate';
import { BankAccountSelect } from '../../BankAccount/BankAccountSelect';

interface Props {
    idCashDeskA?: number;
    menuComponent?: boolean;
}

export const CashReimbursementHistoryfortesoreria = ({ idCashDeskA, menuComponent }: Props) => {

    const { bean, setBean, lista, setLista, instance, handleChange } = useDataBean(_CashReimbursement);
    const single = Singleton.getInstance()
    const [state, setState] = useState<number>(0)
    const _documentos = useDataBean(_DocumentFactory);
    const Egress = useDataBean(_Egress);
    const [docstesoreria, setDocstesoreria] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const [docsvtres, setDocsvtres] = useState<any>([]);
    const [year, setYear] = useState<number>(single.getCurrenYear())
    const [cashDesk, setCashDesk] = useState<number>(null);
    const [crearremmbolso, setcrearremmbolso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [tesoreriadocs, settesoreriadocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [registro, setregistro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [obligation, setobligation] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [egreso, setegreso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [consultar, setconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [resgistropresupuestal, setregistropresupuestal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalConcep, setModalConcep] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalSeeUBL, setModalSeeUBL] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalMoneyBase, setModalMoneyBase] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalAssingRP, setModalAssingRP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    useEffect(() => {
        if (registro.view) {
            verDocumentos();
        }
    }, [registro.view]);

    useEffect(() => {
        if (obligation.view) {
            verDocumentosvdos();
        }
    }, [obligation.view]);

    useEffect(() => {
        if (egreso.view) {
            verDocumentosvtres();
        }
    }, [egreso.view]);

    useEffect(() => {
        if (egreso.view) {
            verDocumentosvtres();
        }
    }, [egreso.view]);
    const validateGetLista = () => {
        if (!year) {
            toast.error("año no valido");
        } else if (isNaN(state)) {
            toast.error("Estado no valido");
        } else if (idCashDeskA ? !idCashDeskA : !cashDesk) {
            toast.error("Caja no valida");
        } else {
            getLista()
        }
    }

    useEffect(() => {
        if (!menuComponent) {
            getLista()
        }
    }, [])

    const getLista = () => {
        instance.getCashReimbursementCatalog(year, idCashDeskA ?? cashDesk, state).then(
            (resp) => {
                if (resp) {
                    // Primero enriqueces los datos
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.Obligation =
                            (user.DataBeanProperties.OBMnemonic ?? "") +
                            "-" +
                            (user.DataBeanProperties.OBConsecutive ?? "") +
                            "-" + (user.DataBeanProperties.OBDate ?? "");
                        user.DataBeanProperties.Egreso =
                            (user.DataBeanProperties.DocMnemonic ?? "") +
                            "-" +
                            (user.DataBeanProperties.DocConsecutive ?? "") +
                            "-" + (user.DataBeanProperties.DocDate ?? "")
                    });

                    // Luego filtras y seteas
                    const filteredList = x.filter(item =>
                        item.DataBeanProperties.IDCashDeskAccount === (idCashDeskA ?? cashDesk)
                    );
                    setLista(filteredList);
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const createCashReimbursementEgress = () => {
        Egress.instance.createCashReimbursementEgress(bean.IDCashReimbursement, bean.CashReimbursementDate, Egress.bean.IDBankingAccount, Egress.bean.Observations, Egress.bean.AccountantDate, _single.getAccountID()).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    setDocstesoreria(resp.DocumentURL);
                    toast.success('Creado')
                    setcrearremmbolso({ ...crearremmbolso, view: false });
                    settesoreriadocs({ ...tesoreriadocs, view: true });
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const vervalorespendientes = () => {
        setconsultar({ ...consultar, view: true });
    }

    const create = () => {
        setBean({
            IDCashDeskAccount: idCashDeskA,
            IDEmployee: single.getAccountID(),
            Year: single.getCurrenYear(),
        })
        setModal({ ...modal, view: true, "name": `Crear Rembolso` });
    }
    const verDocumentos = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.RPIDDocument, null, bean.RPDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const verDocumentosvdos = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.OBIDDocument, null, bean.OBDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsvdos(resp.DocumentURL);
                    setobligation({ ...obligation, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const verDocumentosvtres = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.DocIDDocument, null, bean.DocDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsvtres(resp.DocumentURL);
                    setegreso({ ...egreso, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const createCashReimbursement = () => {
        instance.updateCashReimbursement(bean).then(
            (resp: any) => {
                setModal({ ...modal, "view": false })
                getLista();
                setBean({});
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
        setModal({ ...modal, "view": false });
    }

    const deleteReimbursement = () => {
        instance.deleteCashReimbursement(bean.IDCashReimbursement, single.getCurrenDate()).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const head = [
        { title: 'ID', property: "IDCashReimbursement" },
        { title: 'Caja Dependiente', property: 'IDCashDeskAccount' },
        { title: 'Estado del Proceso', property: 'StateName' },
        // { title: 'Estado del rembolso', property: 'ReimbursementStateName' },
        { title: 'No Externo de Referencia', property: 'SecuenceName' },
        { title: 'Registro Presupuestal', property: 'RPDocumentName' },
        // { title: 'Valor RP', property: 'RPValue' },
        { title: 'Valor Reembolso Presupuestal', property: 'OBValue' },
        { title: 'Valor Reembolso NO Presupuestal', property: 'NonBudgetValue' },
        { title: 'Obligación', property: 'Obligation' },
        { title: 'Comprobante de Egreso', property: 'Egreso' },
        // { title: '% Uso', property: 'Percent' },
        // { title: 'No CDP', property: 'CDPMnemonic' },
        // { title: 'Fecha de CDP', property: 'CDPDate' },
        // { title: 'Documento Contable', property: 'DocMnemonic' },
        // { title: 'Fecha de Documento Contable', property: 'DocDate' },
        // { title: 'Valor Autorizado', property: 'CDPValue' },
        // { title: 'Valor Utilizado', property: 'TotalValue' },
        // { title: '% de Uso', property: 'UsePercent' },
        { title: 'Creado por', property: 'EmployeeName' },
        { title: 'Fecha de Creación', property: 'Since', mask: MASK_DATE },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: "Ver conceptos de Caja", icono: "ri-file-list-line", visible: true, evento: () => { setModalConcep({ ...modalConcep, "view": true, "name": "Conceptos de Caja" }) }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const listaBotonesMenuComp = () => {
        const botones = [
            { titulo: "Generar Reembolso de Caja Menor", icono: "ri-file-list-line", visible: true, evento: () => { setcrearremmbolso({ ...crearremmbolso, "view": true }) }, },
            { titulo: "Ver Registro Presupuestal", icono: "ri-file-list-line", visible: true, evento: () => { setregistro({ ...registro, "view": true }) }, },
            { titulo: "Ver Obligación", icono: "ri-file-list-line", visible: true, evento: () => { setobligation({ ...obligation, "view": true }) }, },
            { titulo: "Ver Comprobante de Egreso", icono: "ri-file-list-line", visible: true, evento: () => { setegreso({ ...egreso, "view": true }) }, },
            // { titulo: "Ver Facturas del Rembolso", icono: "ri-file-list-line", visible: true, evento: () => { setModalSeeUBL({ ...modalSeeUBL, "view": true, "name": "Facturas del Rembolso Seleccionado" }) }, },
            // { titulo: "Agregar Registro Presupuestal a Reembolso de Caja Menor", icono: "ri-file-list-line", visible: true, evento: () => { setregistropresupuestal({ ...resgistropresupuestal, "view": true, "name": "Agregar Registro Presupuestal a Reembolso de Caja Menor" }) }, },
            // { titulo: "Constituir Base de la Caja Menor", icono: "ri-money-dollar-box-line", visible: true, evento: () => { setModalMoneyBase({ ...modalMoneyBase, "view": true, "name": "Constituir Base de la Caja Menor" }) }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const iconButtonsItem = [
        { nombre: "Crear reembolsos de Caja Menor", visible: single.canCreate(), icono: "ri-file-add-line", evento: create },
    ];

    const updateCahs = () => {
        instance.updateCashReimbursement(bean).then(
            (resp) => {
                setModalAssingRP({ ...modalAssingRP, "view": false })
                getLista();
                setBean({});
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }


    return (
        <>
            <BasicPage titulo='Gestionar Reembolsos de Caja Menor'>
                <div className="row mb-3">
                    <div className="col-2">
                        <label className=''>Año:</label>
                        <input type='number' className='form-control' value={year} onChange={(e) => setYear(parseInt(e.target.value))} />
                    </div>
                    <div className="col-5">
                        <CashDeskAccountSelector id={cashDesk} onchange={(e) => { setCashDesk(e) }} />
                    </div>
                    <div className="col-3">
                        <StateReimbursementEditor idSelector={state} onChange={(e) => setState(parseInt(e))} />
                    </div>
                    <div className="col-2 d-flex align-items-end">
                        <BasicButton icon='ri-search-line' eventClick={() => { validateGetLista() }} >Buscar</BasicButton>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mt-4">
                        <BasicButton icon='ri-search-line' eventClick={() => { vervalorespendientes() }} >Consultar Valores Pendientes de Reembolso </BasicButton>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotonesMenuComp()} />
                    </div>
                    <div className="col-md-12">
                        <Modal modal={crearremmbolso} updateModal={setcrearremmbolso} eventModal={createCashReimbursementEgress}>
                            <div className="row">
                                <div className="col-md-6">
                                    <BankAccountSelect label="Banco Orígen de Fondos" idSelector={Egress.bean.IDBankingAccount} onChange={(e) => { Egress.setBean({ ...Egress.bean, "IDBankingAccount": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha" name="AccountantDate" value={Egress.bean.AccountantDate} setDate={(e) => { Egress.setBean({ ...Egress.bean, "AccountantDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Observaciones</label>
                                    <textarea className="form-control" name='Observations' value={Egress.bean.Observations} onChange={Egress.handleChange} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={tesoreriadocs} updateModal={settesoreriadocs}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docstesoreria}

                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={registro} updateModal={setregistro}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={bean.RPIDDocument}
                                        Since={bean.RPDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={obligation} updateModal={setobligation}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docsvdos}
                                        IDDocument={bean.OBIDDocument}
                                        Since={bean.OBDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={egreso} updateModal={setegreso}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docsvtres}
                                        IDDocument={bean.DocIDDocument}
                                        Since={bean.DocDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={consultar} updateModal={setconsultar}>
                            <>
                                <BudgetListForRefund />
                            </>
                        </Modal>
                    </div>
                </div>

            </BasicPage>


            {modalC.view &&
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteReimbursement} >
                    Eliminar Item
                </ModalConfirm>
            }

            {modalSeeUBL.view &&
                <Modal modal={modalSeeUBL} updateModal={setModalSeeUBL}>
                    <CashReimbursementItem _bean={bean} _cashReimbursementDate={bean.Since} _idCashReimbursement={bean.IDCashReimbursement} />
                </Modal>
            }

            {resgistropresupuestal.view &&
                <Modal modal={resgistropresupuestal} updateModal={setregistropresupuestal} eventModal={createCashReimbursement}>
                    <>
                        <RPsEditor label="Registro Presupuestal" _idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "RPDate": e.Since }) }} />
                    </>
                </Modal>
            }

            {modalConcep.view &&
                <Modal modal={modalConcep} updateModal={setModalConcep}>
                    <CashReimbursementBudget idCashReimbursement={bean.IDCashReimbursement} cashReimbursementDate={bean.Since} />
                </Modal>
            }

            {modalMoneyBase.view &&
                <Modal modal={modalMoneyBase} updateModal={setModalMoneyBase} eventModal={() => { }}>
                    <EstablishBaseCashReimbursement idCashReimbursement={bean.IDCashReimbursement} reimbursementDate={bean.Since} />
                </Modal>
            }

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={createCashReimbursement} >
                    <div className="row">
                        <div className="col-12">
                            <label>Año</label>
                            <input type="number" className='form-control' name='Year' value={bean.Year} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label >Número de Referencia Externo:</label>
                            <input type="text" className="form-control" name='SecuenceName' value={bean.SecuenceName} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label >Número de Expediente/Radicado:</label>
                            <input type="text" className="form-control" name='IDFiledNumber' value={bean.IDFiledNumber} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            }

            <Modal modal={modalAssingRP} updateModal={setModalAssingRP} eventModal={updateCahs}>
                <div className="row">
                    <div className="col-md-12">
                        <DocumentStorageEditor label='Registro Presupuestal a Para Asignar' mNemonic='RP' onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "RPDate": e.Since }) }} />
                    </div>
                </div>
            </Modal>

        </>
    )
}